import { get, put, post, axios } from './baseAxios';
import { API_USER_CONTACTS } from '../utils/urls';

const url = API_USER_CONTACTS;

export const getUserContact = (id) => get(`${url}/${id}`);

export const getUserContacts = (request) => get(url, request);

export const updateUserContact = (id, request) => put(`${url}/${id}`, request);

export const createUserContact = (request) => post(url, request);

export const deleteUserContact = (id) => axios.delete(`${url}/${id}`);
